import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import {Marker, Popup, useMap} from 'react-leaflet';
import { Context } from '../store/reducer';
import { Line } from "react-chartjs-2";

import m_rainfall_0 from '../assets/img/marker/weather/m_suii_0.png';
import m_rainfall_1 from '../assets/img/marker/weather/m_suii_1_joushou.png';
import m_rainfall_2_upper from '../assets/img/marker/weather/m_suii_2_joushou.png';
import m_rainfall_2_lower from '../assets/img/marker/weather/m_suii_2_kakou.png';
import m_rainfall_3_upper from '../assets/img/marker/weather/m_suii_3_joushou.png';
import m_rainfall_3_lower from '../assets/img/marker/weather/m_suii_3_kakou.png';
import m_rainfall_4_upper from '../assets/img/marker/weather/m_suii_4_joushou.png';
import m_rainfall_4_lower from '../assets/img/marker/weather/m_suii_4_kakou.png';
import m_rainfall_5_upper from '../assets/img/marker/weather/m_suii_5_joushou.png';
import m_rainfall_5_lower from '../assets/img/marker/weather/m_suii_5_kakou.png';
import m_rainfall_6_upper from '../assets/img/marker/weather/m_suii_6_joushou.png';
import m_rainfall_6_lower from '../assets/img/marker/weather/m_suii_6_kakou.png';
import hanrei_tooltip from '../assets/img/hanrei_tooltip.png';
import icon_info from '../assets/img/icon_info.png';
import m_rainfall_2 from "../assets/img/marker/weather/m_dam-suii_2.png";
import m_rainfall_3 from "../assets/img/marker/weather/m_dam-suii_3.png";
import m_rainfall_4 from "../assets/img/marker/weather/m_dam-suii_4.png";
import m_rainfall_5 from "../assets/img/marker/weather/m_dam-suii_5.png";

/**
 * 34: 河川管理情報システム 水位日集計
 * @param options
 * @returns {null}
 * @constructor
 */
const Component = ({options}) => {
    
    const handleSpotData = (item) => {

        let ret = []

        ret.push(<dl className='dl-list is-modal-spot'><dt>データ種別</dt><dd>{item["station_type_label"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>事業所名</dt><dd>{item["office_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>データ所管</dt><dd>{item["department"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>水系名</dt><dd>{item["water_system_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>河川名</dt><dd>{item["river_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所番号</dt><dd>{item["observatory_id"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所名</dt><dd>{item["name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{item["lat"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{item["lng"]}</dd></dl>)

        return ret
    }

    const map = useMap()
    const { state } = useContext(Context);

    return Object.keys(state["vis_34"].data).map((key, index) => {
        
        const item = state["vis_34"].data[key];
        
        let labels = [];
        // let value1_list = [];
        // let value2_list = [];


        let suii_value1_list = [];
        let suii_value2_list = [];
        let suii_value3_list = [];
        let suii_value4_list = [];
        let suii_value5_list = [];
        let suii_value6_list = [];
        
        Object.keys(item.rain_list).map(key => {

            const rainData = item.rain_list[key];
            
            labels.push(rainData.datetime);
            
            suii_value1_list.push(rainData.value1);
            
            // はん濫危険
            suii_value2_list.push(item.water_fixed5);
            
            // 避難判断
            suii_value3_list.push(item.water_fixed4);
            
            // はん濫注意
            suii_value4_list.push(item.water_fixed3);
            
            // 水防団待機
            suii_value5_list.push(item.water_fixed2);

            // 零点高
            suii_value6_list.push(item.water_fixed1);
        })

        // マーカー色決定用に現在のスライダーの値を取得する
        const currentTenMinutesValue = suii_value1_list[state.timeIdx] ? suii_value1_list[state.timeIdx] : 0;
        const prevTenMinutesValue = suii_value1_list[state.timeIdx - 1] ? suii_value1_list[state.timeIdx - 1] : 0;



        /**
         * 判定対象の値が途中で存在しない場合に、存在する中で1番近い下位レベルのアイコンを表示する処理。
         * @param index
         * @returns {*}
         */
        const getProperIcon = (index) => {

            const iconList = [];
            iconList[0] = {upper: m_rainfall_2_upper, lower : m_rainfall_2_lower}; //平常は常に存在する。
            iconList[1] = item.water_fixed2 != "" ? {upper: m_rainfall_3_upper, lower : m_rainfall_3_lower} : null; //水防団待機が存在するか。
            iconList[2] = item.water_fixed3 != "" ? {upper: m_rainfall_4_upper, lower : m_rainfall_4_lower} : null; //はんらん注意が存在するか。
            iconList[3] = item.water_fixed4 != "" ? {upper: m_rainfall_5_upper, lower : m_rainfall_5_lower} : null; //避難判断が存在するか。
            iconList[4] = item.water_fixed5 != "" ? {upper: m_rainfall_6_upper, lower : m_rainfall_6_lower} : null; //氾濫危険が存在するか。

            // レベルを順に下げていき、アイコンが設定されているものを返す。
            for (let i = 4; i >= 0; i--) {

                // 上のレベルは無関係なのでスキップ
                if (i > index) {
                    continue;
                }

                if (iconList[i]) {
                    return iconList[i];
                }
            }
        }
        
        // グレー
        let icon = m_rainfall_1

        if (currentTenMinutesValue === "**"
          || currentTenMinutesValue === "--"
          || currentTenMinutesValue === "") {
            // 欠測: グレー
            icon = m_rainfall_1

        } else if (currentTenMinutesValue === "MM"
          || currentTenMinutesValue === "CC") {
             // 閉局・メンテナンス: バツ付きグレー
            icon = m_rainfall_0
        } else if (item.water_fixed2 != "" && currentTenMinutesValue < item.water_fixed2) {
            // 平常(水防団待機 未満): 白
            const tmpIcon = getProperIcon(0);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower

        } else if (item.water_fixed3 != "" && currentTenMinutesValue < item.water_fixed3) {
            
            // 氾濫注意 未満: 青
            const tmpIcon = getProperIcon(1);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower

        } else if (item.water_fixed4 != "" && currentTenMinutesValue < item.water_fixed4) {
            
            // 避難判断 未満: 黄色
            const tmpIcon = getProperIcon(2);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower

        } else if (item.water_fixed5 != "" && currentTenMinutesValue < item.water_fixed5) {
            
            // 氾濫危険 未満: 赤
            const tmpIcon = getProperIcon(3);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower

        } else if (item.water_fixed5 != "" && currentTenMinutesValue >= item.water_fixed5) {
            
            // 氾濫危険 以上: 紫
            const tmpIcon = getProperIcon(4);

            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower
        } else {

            // 判定すべき値が全てブランクの場合、平常とする
            const tmpIcon = getProperIcon(0);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower
        }

        // if (item["name"] === "三篠橋(国)") {
        //     console.log("貯水位", currentTenMinutesValue)
        //     console.log("常時満水位[EL.m]", item.dam_fixed4)
        //     console.log("常時満水位[EL.m] != \"\"", (item.dam_fixed4 != ""))
        //     console.log("ただし書き操作開始水位", item.dam_fixed5)
        //     console.log("water_fixed5 != \"\"", (item.water_fixed5 != ""))
        //     console.log("サーチャージ水位", item.dam_fixed6)
        //     console.log("currentTenMinutesValue < item.dam_fixed4", (currentTenMinutesValue < item.dam_fixed4))
        //     console.log("item[\"name\"]", item["name"])
        //     console.log("icon", icon)
        // }
        
        const iconUrl = new L.Icon({
            iconUrl: icon,
            iconRetinaUrl: icon,
            iconSize: [35, 35],
            iconAnchor: [17, 23],
            popupAnchor: [0, -50]
        });
        

        return (
          <>
              <Marker
                position={[item.lat, item.lng]}
                icon={iconUrl}
              >
                  <Popup autoPan={false} minHeight={400} maxHeight={800} minWidth={600} closeOnClick>
                      
                      <div className={"modal-detail"}>
                      {
                          handleSpotData(item)
                      }

                      <div className="p-graph">
                          <div className="p-graph__main">
                              
                      <Line
                        height={400}
                        width={500}
                        data={{
                            "labels": labels,
                            "datasets": [
                              
                                {
                                    "myFixedData": false,
                                    yAxisID: 'suii_y',
                                    "label": "水位[m]",
                                    "data": suii_value1_list,
                                    "borderColor": "gray",
                                    "backgroundColor": "gray"
                                },
                                {
                                    "myFixedData": true,
                                    yAxisID: 'suii_y',
                                    "label": "はん濫危険[m]",
                                    "data": suii_value2_list,
                                    "borderColor": "purple",
                                    "backgroundColor": "purple"
                                },
                                {
                                    "myFixedData": true,
                                    yAxisID: 'suii_y',
                                    "label": "避難判断[m]",
                                    "data": suii_value3_list,
                                    "borderColor": "red",
                                    "backgroundColor": "red"
                                },
                                {
                                    "myFixedData": true,
                                    yAxisID: 'suii_y',
                                    "label": "はん濫注意[m]",
                                    "data": suii_value4_list,
                                    "borderColor": "orange",
                                    "backgroundColor": "orange"
                                },
                                {
                                    "myFixedData": true,
                                    yAxisID: 'suii_y',
                                    "label": "水防団待機[m]",
                                    "data": suii_value5_list,
                                    "borderColor": "blue",
                                    "backgroundColor": "blue"
                                },
                            ]
                        }}
                        options={{
                            // responsive: true,
                            maintainAspectRatio: true,
                            elements: {
                                point: {
                                    radius : function(context){

                                        // 固定データは丸をつけない。
                                        if (context.dataset.myFixedData) {
                                            return 0;
                                        }
                                        
                                        return context.dataIndex === state.timeIdx ? 8 : 0
                                    },
                                }
                            },
                            scales: {

                                x: {
                                    ticks: {
                                        maxTicksLimit: 24, // 表示する最大ラベル数
                                        autoSkip: true // 全てのラベルを表示する場合はfalseに設定
                                    }
                                },
                                
                                suii_y: {
                                    type: 'linear',
                                    display: true,
                                    position: 'left',
                                    max: 9.00,
                                    min: -1.00,
                                    title: {
                                        display: true,
                                        text: "水位 [m]"
                                    }
                                },
                            }
                        }}
                        id="chart-key"
                      />

                      </div>

                          <div className="p-graph__hanrei">
                              <div>
                                  <a href="" className="modal-link __ttl" onClick={e => {e.preventDefault(); return false;}} style={
                                      {
                                      '--hover-before-background': `url(${icon_info})`,
                                      '--hover-after-background': `url(${hanrei_tooltip})`
                                      }
                                  }>凡例について</a>
                              </div>

                              <div className="p-graph-hanrei">
                                  <ul className="p-graph-hanrei__list">
                                      <li><span className="pgh-item pgh-suii"></span><span className="pgh-txt">水位</span></li>
                                      <li><span className="pgh-item pgh-hanrankiken320"></span><span className="pgh-txt">はん濫危険 <span className="__sm">{item.water_fixed5 ? item.water_fixed5+"m" : ""}</span></span></li>
                                      <li><span className="pgh-item pgh-hinanhandan280"></span><span className="pgh-txt">避難判断 <span className="__sm">{item.water_fixed4 ? item.water_fixed4+"m" : ""}</span></span></li>
                                      <li><span className="pgh-item pgh-hanranchuui"></span><span className="pgh-txt">はん濫注意 <span className="__sm">{item.water_fixed3 ? item.water_fixed3+"m" : ""}</span></span></li>
                                      <li><span className="pgh-item pgh-suboudan"></span><span className="pgh-txt">水防団待機 <span className="__sm">{item.water_fixed2 ? item.water_fixed2+"m" : ""}</span></span></li>
                                      <li><span className="pgh-item pgh-zerotentaka"></span><span className="pgh-txt">零点高 <span className="__sm">T.P 〜{item.water_fixed1 ? item.water_fixed1+"m" : ""}</span></span></li>
                                  </ul>
                              </div>
                              
                          </div>
                      </div>
                      </div>
                  </Popup>
              </Marker>

          </>
        );
    })
}

export default Component
